import React from 'react';
import styles from './Alert.module.scss';

export enum AlertType {
  Information = 'Information',
  Warning = 'Warning',
  Error = 'Error',
  Success = 'Success',
}

export interface IAlert {
  id?: string;
  children?: React.ReactNode;
  type?: AlertType;
}

export default function Alert({ id, children, type = AlertType.Information }: IAlert) {
  const alertClasses = `${styles.alert} ${styles[type]}`;

  return (
    <div id={id} role="alert" className={alertClasses}>
      {children}
    </div>
  );
}
